import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const postRelated = {

		init: function() {
			this.cacheDOM();
			if (!this.$slider.length) {
				return;
			}
			this.sliderInit();
		},

		cacheDOM: function() {
			this.$slider = $('.js-post-related-slider');
		},

		sliderInit: function() {
			const sliderConfig = {
				slidesToShow: 2,
				infinite: false,
				autoplay: false,
				arrows: true,
				prevArrow: $('.js-post-related-prev'),
				nextArrow: $('.js-post-related-next'),
				responsive: [
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 1.5
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1.1
						}
					}
				]
			};

			sliders.initializeSlider('.js-post-related-slider', sliderConfig);
		},

	};

	postRelated.init();

});
